import ActionTypes from '../constants';

const initialState = {
    productCategories: {},
    productCategory: {}
    // loading: false,
};

const productCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPRODUCTCATEGORYSUCCESS:
            return {
                ...state,
                productCategories: action.payload,
            }
        case ActionTypes.GETPRODUCTCATEGORYBYIDSUCCESS:
            return {
                ...state,
                productCategory: action.payload,
            }
        default:
            return state;
    }
}

export default productCategoryReducer;